import { PhoneNumber } from '@weave/schema-gen-ts/dist/schemas/phone/callroute/v1/callroute_service.pb';
import { CallRouteV1 } from '@frontend/api-call-route';
import { PhoneOverrideType } from '../../components/override/types';

export type ExtendedCallRoute = CallRouteV1.Types.ListIO['output']['callRoutes'][number] & {
  phoneNumbers: PhoneNumber[];
  callRoutePhoneOverride?: PhoneOverrideType;
};

export const NodeAction = {
  Add: 'add',
  Edit: 'edit',
  Delete: 'delete',
} as const;

export type NodeActionType = (typeof NodeAction)[keyof typeof NodeAction];
